/* @flow */

import React, { Component, Fragment } from 'react';
import type { $BaseWidgetState } from '../../types/BaseWidgetState';
import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $DealerBrand } from '../../types/Dealer';
import renderTemplate from '../../utils/TemplateRenderer';
import Globals from '../../constants/Globals';
import WidgetDealerKeys from '../../constants/WidgetDealerKeys';
import CompanyForms from '../../constants/CompanyForms';
import WidgetParagraph from '../WidgetParagraph/WidgetParagraph';
import { TemplateMarketPropertyKeys } from '../../templates/TemplateMarketProperties';
import { getConfigurationMarketProperty } from '../../utils/WidgetUtils';

type $Props = {
  widgetState: $BaseWidgetState,
  nameLineModifierClass?: string
};

export function getDealerBaseNames(dealer: $Dealer, configuration: $Configuration, marketCode: string): Array<string> {
  const dealerBaseNames: Array<string> = [];
  const marketPropertiesValues: Array<string> = []

  const placeholderKeys = [
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_1,
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_2,
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_3
  ];

  for (let i = 0; i < placeholderKeys.length; i++) {
    const marketProperty = getConfigurationMarketProperty(configuration, marketCode, placeholderKeys[i]);
    let marketPropertyValue: string = '';

    if (marketProperty && marketProperty.template && Array.isArray(marketProperty.template)) {
      marketPropertyValue = marketProperty.template.join('');
    }
    else if (typeof marketProperty === 'string') marketPropertyValue = marketProperty;

    marketPropertiesValues.push(marketPropertyValue)
  }

  const name1ExistsInValues = marketPropertiesValues.findIndex(value => value.includes('{name1}')) !== -1

  for (let i = 0; i < marketPropertiesValues.length; i++) {
    let marketPropertyValue = marketPropertiesValues[i]
    if (marketPropertyValue) {
      if (
        dealer.baseInfo &&
        dealer.baseInfo.companyForm === CompanyForms.AFFILIATE_OF_DAIMLER_AG &&
        marketPropertyValue.includes('{businessName}') &&
        !name1ExistsInValues
      ) {
        marketPropertyValue = marketPropertyValue.replace('{businessName}', '{name1}');
      }

      const nameLineValue = renderTemplate(`${marketPropertyValue}`, dealer);
      if (nameLineValue) dealerBaseNames.push(nameLineValue);
    }
  }
  return dealerBaseNames;
}

export function getBrandBusinessName(dealer: $Dealer, brandCode: string): $Dealer {
  if (dealer && dealer.brands && Array.isArray(dealer.brands) && dealer.brands.length > 0) {
    const dealerBrand = dealer.brands.find((brand: $DealerBrand) => brand.brand && brand.brand.code === brandCode);
    if (dealerBrand && dealerBrand.businessName) {
      return {
        ...dealer,
        baseInfo: {
          ...dealer.baseInfo,
          businessName: dealerBrand.businessName
        }
      };
    }
    else return { ...dealer };
  }
  else return { ...dealer };
}

export default class DealerBaseName extends Component<$Props> {

  render() {
    const { widgetState } = this.props;
    const { dealer, configuration, settings } = this.props.widgetState;
    const dealerData: $Dealer = getBrandBusinessName(dealer || {}, Globals.DEFAULT_DEALER_BRAND_CODE);
    const dealerBaseNames: Array<string> = getDealerBaseNames(dealerData, configuration || {}, settings.market || '');

    const dealerDefaultNameLines: Array<string> = [
      WidgetDealerKeys.DEALER_NAME_LINE_1,
      WidgetDealerKeys.DEALER_NAME_LINE_2,
      WidgetDealerKeys.DEALER_NAME_LINE_3,
      WidgetDealerKeys.DEALER_NAME_LINE_4,
      WidgetDealerKeys.DEALER_NAME_LINE_5
    ];

    return (
      <div className="dl-dealer-base-names">
        {dealerBaseNames && dealerBaseNames.length > 0 ? (
          dealerBaseNames.map((nameLine: string, idx: number) => (
            <p
              key={idx}
              className={`dl-dealer-base-names--name
              dl-dealer-base-name-${++idx} ${this.props.nameLineModifierClass ||
                ""}`}
            >
              {nameLine}
            </p>
          ))
        ) : (
            <Fragment>
              {dealerDefaultNameLines.map((nameLine: string, idx: number) => (
                <WidgetParagraph
                  key={idx}
                  widgetState={widgetState}
                  widgetFieldKey={nameLine}
                  modifierClass={[
                    "dl-dealer-base-names--name",
                    `dl-dealer-base-name-${++idx}`,
                    this.props.nameLineModifierClass || ""
                  ]}
                />
              ))}
            </Fragment>
          )}
      </div>
    );
  }
}
